<style>

.tabs{
  display: flex;
  flex-direction: row;
  justify-content: center;
  /* color: gray; */
}
.tab0-light{
  border: 1px gray solid;
  border-radius: 20px 0 0 20px;
  padding: 5px 10px;
  background-color: rgba(255,255,255,0.6);
}
.tab1-light{
  border: 1px gray solid;
  border-radius: 0 20px 20px 0;
  padding: 5px 15px;
  background-color: rgba(255,255,255,0.6);
}
.selected-light{
  background-color: rgba(0,0,0,0.6);
  box-shadow: 0 0 10px rgba(0,0,0,1);
  color: white;
  text-decoration: underline;
}

.tab0-dark{
  border: 1px gray solid;
  border-radius: 20px 0 0 20px;
  padding: 5px 10px;
  background-color: rgba(0,0,0,0.6);
}
.tab1-dark{
  border: 1px gray solid;
  border-radius: 0 20px 20px 0;
  padding: 5px 15px;
  background-color: rgba(0,0,0,0.6);
}
.selected-dark{
  background-color: rgba(255,255,255,0.5);
  box-shadow: 0 0 10px rgba(255,255,255,1);
  color: white;
  text-decoration: underline;
}

.text1{
  display: grid;
  grid-template-columns: 20px auto;
}
.text1-icon{
  grid-column: 1;
}
.text1-text{
  grid-column: 2;
}
.text2{
  display: grid;
  grid-template-columns: auto 20px;
}
.text2-text{
  grid-column: 1;
}
.text2-icon{
  grid-column: 2;
}
</style>

{#if theme == "dark"}

<div class="tabs">
  <div class="tab0-dark {tabs[0].selected ? 'selected-dark' : ''}" on:click="{invert}">
    {tabs[0].name}
  </div>
  <div class="tab1-dark {tabs[1].selected ? 'selected-dark' : ''}" on:click="{invert}">
    {tabs[1].name}
  </div>
</div>

{:else}

<div class="tabs">
  <div class="tab0-light {tabs[0].selected ? 'selected-light' : ''}" on:click="{invert}">
    {tabs[0].name}
  </div>
  <div class="tab1-light {tabs[1].selected ? 'selected-light' : ''}" on:click="{invert}">
    {tabs[1].name}
  </div>
</div>

{/if}


<script>

export let tabs = [ {name: 'Personal', selected: true}, {name: 'Business', selected: false } ];

export let theme = "dark";

function invert() {
  tabs[0].selected = !tabs[0].selected;
  tabs[1].selected = !tabs[1].selected;
}

</script>